import { Tag } from '@comet/blocks';
import { styled } from '@comet/styled';

export const StyledTag = styled(Tag)`
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 16px;
  cursor: pointer;
`;
